import { bootstrapApplication } from '@angular/platform-browser';
import { preloadAppConfig } from '~/constants/config.constant';
import { App } from './app/app';
import { appConfig } from './app/app.config';

preloadAppConfig()
  .then(() => bootstrapApplication(App, appConfig))
  .catch((err) => console.error(err));
